import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FilterByType, FilterSortType, SortByType } from 'app/model/constant';
import {FormBuilder, FormGroup} from '@angular/forms';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { FilterSortModel } from 'app/model/booking/booking-filter-sort-model';
import { Subscription } from 'rxjs/Subscription';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'ota-dialog-filter-booking',
  templateUrl: './dialog-filter-booking.component.html',
  styleUrls: ['./dialog-filter-booking.component.scss']
})
export class DialogFilterBookingComponent implements OnInit, OnDestroy {
  @Input('bookingPayload') bookingPayload: FormGroup;
  @Input('listItems') listItems: FilterSortModel[];
  @Input('filterType') filterType: FilterSortType;
  @Input('filterTitle') filterTitle: string;

  public _bookingPayload: FormGroup;

  private subscriptionFilter: Subscription;

  constructor(
              @Inject(MD_DIALOG_DATA)
              public data: any,
              public dialogRef: MdDialogRef<DialogFilterBookingComponent>,
              private formBuilder: FormBuilder,
              private appConfigService: AppConfigService,
              private utilitiesService: UtilitiesService
              ) { }

  ngOnInit() {
    this._bookingPayload = this.formBuilder.group({
      'filterSort': [this.filterType === FilterSortType.sort ?
        (this.bookingPayload.controls.sortBy ? this.bookingPayload.controls.sortBy.value : SortByType.bookingDate) :
        (this.bookingPayload.controls.filterBy ? this.bookingPayload.controls.filterBy.value : FilterByType.all)
      ]
    });

    this.subscriptionFilter =  this._bookingPayload.controls.filterSort.valueChanges
    .subscribe((val) => {
      if (this.filterType === FilterSortType.sort && this.bookingPayload.controls.sortBy) {
        this.bookingPayload.controls.sortBy.setValue(val);
      } else if (this.filterType === FilterSortType.filter && this.bookingPayload.controls.filterBy) {
        this.bookingPayload.controls.filterBy.setValue(val);
      }
      this.dialogRef.close();
    });
  }

  ngOnDestroy() {
    this.subscriptionFilter && this.subscriptionFilter.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialog-filter-booking/dialog-filter-booking.component.ts